exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transparent[data-v-7c5bd874]{background:rgba(0,0,0,.9)!important}.no-transparent[data-v-7c5bd874]{background:rgba(0,0,0,.5)!important}.nav[data-v-7c5bd874]{height:80px;width:100%;display:flex;justify-content:space-evenly;align-items:center;z-index:9;position:sticky;top:0}.nav a[data-v-7c5bd874]{padding-right:74px}.nav .logo[data-v-7c5bd874]{width:169px;height:47px;display:flex;align-items:center}.nav .logo img[data-v-7c5bd874]{max-height:100%;max-width:100%}.nav a[data-v-7c5bd874]{color:#b3b3b3;text-decoration:none;padding-left:74px;font-size:20px}.nav a.router-link-exact-active[data-v-7c5bd874]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c5bd874","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pcHeader.vue
// module id = 131
// module chunks = 0